module.exports = __webpack_public_path__ + "img/noun_report.9b662cf9.svg";